// CustomEdge.tsx
import type { EdgeProps } from '@xyflow/react';
import styled from '@emotion/styled';
import { BaseEdge, EdgeLabelRenderer, getBezierPath, Position } from '@xyflow/react';
import { observer } from 'mobx-react';

export const ConditionThenEdge = observer(
  ({ id, sourceX, sourceY, markerEnd, targetX, targetY, style = {} }: EdgeProps) => {
    const [edgePath, labelX, labelY] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition: Position.Right, // 오른쪽으로 나감
      targetX,
      targetY,
      targetPosition: Position.Top, // 위에서 들어옴
    });

    return (
      <>
        <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={{ ...style }} />
        <EdgeLabelRenderer>
          <TrueLabel
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
          >
            true
          </TrueLabel>
        </EdgeLabelRenderer>
      </>
    );
  },
);

const TrueLabel = styled.div`
  display: flex;
  padding: 3px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.colors['border-gray-lighter']};
  background: ${props => props.theme.colors['bg-white']};
  font-size: 12px;
  height: fit-content;
  line-height: 1;
  pointer-events: all;
  width: fit-content;
  white-space: nowrap;
`;
